import { DialogContentTextProps } from "@material-ui/core";

export const MuiDialogContentText: DialogContentTextProps = {
  color: "textPrimary",
  variant: "body2",
};
